import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { actions } from "../../../redux/store/store";
import { useLoginMutation } from "../../../api/auth";
import "../../../styles/_login.scss";
import brandLogo from "../../../images/logo-better-truck.svg";
import { datadogRum } from "@datadog/browser-rum";

export default function Login(props) {
  const { onStopUserQuery, setFetchUserState } = props;
  const location = useLocation();
  const [username, setUsername] = useState(
    (location.state && location.state.login) || ""
  );
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [login, { isLoading }] = useLoginMutation();

  const performLogin = async (e) => {
    e.preventDefault();

    setError("");
    setFetchUserState(false);
    const { data: user, error: loginError } = await login({
      username,
      password,
      loginType: "web",
    });

    if (user) {
      setFetchUserState(true);
      localStorage.setItem(
        "user_metro",
        JSON.stringify(
          user?.metros.map((metro) => {
            return metro.name;
          })
        )
      );
      if (
        ["admin", "root", "bookkeeper", "metro_manager"].includes(user.role)
      ) {
        onStopUserQuery(false);
        actions.notifications.add({
          message: "Logged in",
          status: "success",
        });
        actions.auth.setCurrentUser(user);
        datadogRum.setUser({
          id: 'USER_ID',
          name: 'John Doe',
          email: 'john.doe@example.com',
          role: 'admin',
        });
        if (user?.role === "bookkeeper") navigate("/deposit");
        else navigate("/drivers");
      } else {
        setError("This user does not have admin rights");
      }
    } else {
      if (loginError.status === 401 || loginError.originalStatus === 401) {
        setError("Incorrect username or password");
      } else {
        setError((loginError.data && loginError.data.message) || "Something went wrong");
      }
    }
  };
  //   [username, password]
  // );

  // const toRegistration = (e) => {
  //   e.preventDefault();
  //   navigate("/register");
  // };

  const toForgotPassword = (e) => {
    e.preventDefault();
    navigate("/forgotPassword");
  };

  return (
    <div className="screen screen_flex">
      <div className="container container_contain-center loginmain">
        <img className="brandlogo" src={brandLogo} alt="" />
        <div className="login" style={{ marginTop: '20px'}}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: 10
            }}
          >
            <button
              className="btn btn_block btn_accent"
              onClick={props?.handleLogin}
            >
              Login using zitadel
            </button>
          </div>
          <div style={{ width: '100%', display: 'flex', alignItems: 'center', marginBottom: '-20px' }}>
            <div style={{ width: '100%', height: 1, backgroundColor: '#ccc' }} />
            <span style={{ padding: '0 10px' }}>or</span>
            <div style={{ width: '100%', height: 1, backgroundColor: '#ccc' }} />
          </div>
          <form>
            <div className="form__item">
              <label className="form__label" htmlFor="login">
                Email
              </label>
              <input
                id="login"
                className="form__input"
                type="email"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="off"
              />
            </div>
            <div className="form__item">
              <label className="form__label" htmlFor="password">
                Password
              </label>
              <input
                id="password"
                className="form__input" /*form__input-invalid <= class for invalid value*/
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="off"
              />
              {/*example msg for invalid*/}
              {/*<div className="form__msg form__msg_invalid">value invalid</div>*/}
            </div>
            <div className="form__item form__item_min-margin">
              <button
                className="btn btn_block btn_accent"
                disabled={isLoading}
                onClick={performLogin}
                type="submit"
              >
                Login
              </button>
            </div>
            {error && (
              <div className="form__item form__item_min-margin">
                <div className="form__msg form__msg_summary form__msg_invalid">
                  {error}
                </div>
              </div>
            )}

            {/* <div className="login__link-holder">
              <a href="/register" onClick={toRegistration}>Register</a>
            </div>
             */}

            <div className="login__link-holder">
              <a href="/forgotPassword" onClick={toForgotPassword}>
                Forgot password ?
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
